export default "__VITE_ASSET__DodNLBR___"